<template lang='pug'>
.biz.form.component
  span.boldtext https://www.bluefaucet.com/m/
  input( ref='editable' v-model='slug' )
  bf-button.basic( @click.native='update' :disabled='!updatable' )
    template( v-slot:text ) Update
</template>

<script>
import { auth, db, str } from '@/main'
import api from '@/lib/apis'

export default {
  name: 'biz.form.component',

  components: {
  },


  props: {
    usr: { type: Object, required: true }
  },

  data() {
    return {
      original: this.usr.displayName,
      slug: this.usr.displayName,
      d: null
    }
  },

  computed: {
    updatable() {
      return this.original != this.slug
    }
  },

  methods: {
    update() {
      let params = { params: { uid: this.usr.uid, bid: this.usr.displayName, slug: this.slug } }
      this.$http.get( api.update, params ).then( r => {
        console.log( r )
        this.d = r.data 
      })
    }
  }
}
</script>

<style scoped lang='stylus'>
.biz
  background white
  padding 32px
  border-radius 7px
  h4
    margin-bottom 16px
  input
    width 24em
    font-size 1.2em
    background rgba( 0 0 0 .05 )
</style>
